import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

export default function SummaryAccordion({ children, title }) {
  return (
    <>
      <Accordion mt={2}>
        <AccordionSummary
          sx={{
            '& .MuiAccordionSummary-content': {
              justifyContent: 'center',
            },
            fontWeight: 'bold',
          }}
          expandIcon={<ExpandMoreIcon />}
        >
          {title}
        </AccordionSummary>
        <AccordionDetails sx={{ display: 'flex', justifyContent: 'center' }}>
          {children}
        </AccordionDetails>
      </Accordion>
    </>
  );
}
